
export const CalculateFeesSup = (total, products, feeDetails, transaction) => {
        const calculatedFees = [];
    if (!Array.isArray(feeDetails)) return calculatedFees;
feeDetails?.forEach((fee) => {
    if (fee?.fee_frequency === 'per_deal' && fee?.buyer_organization_ulid === null) 
{
    let feeAmount = 0;

    switch (fee.fee_method) {
        case 'sofr_margin': {
            const sofrRate = transaction?.platformCharges?.sofr_rate || 0;
            const sofrPercentage = sofrRate + fee.fee_value;
            feeAmount = (sofrPercentage / 100) * total;
            break;
        }

        case 'percentage': {
            const percentage = fee.fee_value;
            feeAmount = (percentage / 100) * total;
            break;
        }

        case 'lumpsum': {
            feeAmount = fee.fee_value;
            break;
        }

        case 'per_mt': {
            products.forEach((product) => {
                feeAmount += product.volume * fee.fee_value;
            });
            break;
        }

        default:
            break;
    }

    calculatedFees.push({
        fee_type: fee.fee_type,
        fee_amount: Number(feeAmount.toFixed(2)),
        other_fees_text: fee?.other_fees_text,

    });}
    else return false
});
const filteredResult = calculatedFees?.filter(fee =>
    fee.fee_type !== "trade_ops_service_fees" &&
    fee.fee_type !== "dispute_claim_management_fees"&&
    fee.fee_type !== "trade_acceleration_charges"
);
return filteredResult;
};